import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { Columns } from '@components/Columns';

export const StyledOneRegistrySectionBackImage = styled(Box)<{ imageUrl: string }>`
  position: relative;
  background: url(${({ imageUrl }) => cloudAssetUrl(imageUrl)});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  min-height: 600px;
  margin-top: -40px;
  ${themeMediaQuery('below_sm')} {
    background-position: center;
    min-height: 500px;
  }
  ${themeMediaQuery('xl')} {
    min-height: 800px;
  }
`;

export const StyledOneRegistrySection = styled(Box)`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #e2f5ff 24.08%, #c2e8fd 100%);
  position: absolute;
  top: 100px;
  ${themeMediaQuery('below_sm')} {
    top: 80px;
  }
`;

export const CharityTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 350px;
  }
  .text-pairing-title {
    max-width: 500px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 550px;
    }
    .text-pairing-body {
      max-width: 450px;
    }
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 380px;
    }
  }
`;

export const HeroTextColumn = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  ${themeMediaQuery('sm')} {
    max-width: 55rem;
  }
  ${themeMediaQuery('md')} {
    max-width: 90rem;
  }
`;
